// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';
import { v1ErrorSchema } from './v1/errorSchema';
import { v1NotFoundErrorSchema } from './v1/notFoundErrorSchema';
import { v1UnauthorizedErrorSchema } from './v1/unauthorizedErrorSchema';

export const deleteHourPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
  id: z.number().int().describe("Time entry ID"),
});

export const deleteHourHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Time entry deleted
 */
export const deleteHour200Schema = z.object({});

/**
 * @description Unauthorized
 */
export const deleteHour401Schema = z.lazy(() => v1UnauthorizedErrorSchema);

/**
 * @description Time entry not found
 */
export const deleteHour404Schema = z.lazy(() => v1NotFoundErrorSchema);

/**
 * @description Cannot delete locked or invoiced time entry
 */
export const deleteHour422Schema = z.lazy(() => v1ErrorSchema);

export const deleteHourMutationResponseSchema = z.lazy(() => deleteHour200Schema);
